import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './global/components/page-not-found/page-not-found.component';

/**
 * This Application uses lazy loading for all the internal modules.
 */

const routes: Routes = [
	/**
	 *Default route should always serve home page
	 */
	{
		path: '',
		loadChildren: () =>
			import('./pages/home/home-routing.module').then((m) => m.HomeRoutingModule),
	},
	/**
	 * Account Module
	 */
	{
		path: 'account',
		loadChildren: () =>
			import('./pages/account/account-routing.module').then((m) => m.AccountRoutingModule),
	},
	/**
	 * Redirect to login/register component of account Module
	 */
	{ path: 'login', redirectTo: 'account/login', pathMatch: 'full' },
	{ path: 'register', redirectTo: 'account/register', pathMatch: 'full' },
	/**
	 * Fundraiser Module
	 */
	{
		path: 'fundraising',
		loadChildren: () =>
			import('./pages/fundraiser/fundraiser-routing.module').then(
				(m) => m.FundraiserRoutingModule
			),
	},
	/**
	 * Redirect to Create component of Fundraiser Module
	 */
	{ path: 'create', redirectTo: 'fundraising/create', pathMatch: 'full' },
	{ path: 'start', redirectTo: 'fundraising/start', pathMatch: 'full'},
	/**
	 * Search Module
	 */
	{
		path: 'search',
		loadChildren: () =>
			import('./pages/search/search-routing.module').then((m) => m.SearchRoutingModule),
	},
	/**
	 * Donation Module
	 */
	{
		path: 'donate',
		loadChildren: () =>
			import('./pages/donation/donation-routing.module').then((m) => m.DonationRoutingModule),
	},
	/**
	 * Profile Module
	 */
	{
		path: 'profile',
		loadChildren: () =>
			import('./pages/user/profile/profile-routing.module').then(
				(m) => m.ProfileRoutingModule
			),
	},
	/**
	 * Dashboard Module
	 */
	{
		path: 'dashboard',
		loadChildren: () =>
			import('./pages/user/dashboard/dashboard-routing.module').then(
				(m) => m.DashboardRoutingModule
			),
	},
	/**
	 * My Fundraisers Module
	 */
	{
		path: 'my-fundraisers',
		loadChildren: () =>
			import('./pages/user/my-fundraisers/my-fundraisers-routing.module').then(
				(m) => m.MyFundraisersRoutingModule
			),
	},
	/**
	 * Custom Branding Module
	 */
	{
		path: 'custom-branding',
		loadChildren: () =>
			import('./pages/user/custom-branding/custom-branding-routing.module').then(
				(m) => m.CustomBrandingRoutingModule
			),
	},
	/**
	 * Balance Module
	 */
	{
		path: 'balance',
		loadChildren: () =>
			import('./pages/user/balance/balance-routing.module').then(
				(m) => m.BalanceRoutingModule
			),
	},
	/**
	 * Donations Module
	 */
	{
		path: 'donations',
		loadChildren: () =>
			import('./pages/user/donations/donations-routing.module').then(
				(m) => m.DonationsRoutingModule
			),
	},
	{
		path: 'custom-domain',
		loadChildren: () =>
			import('./pages/user/custom-domain/custom-domain-routing.module').then(
				(m) => m.CustomDomainRoutingModule
			),
	},
	/**
	 * Error page
	 */
	{
		path: '**',
		pathMatch: 'full',
		component: PageNotFoundComponent,
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
